import { createAuth0Client } from '@auth0/auth0-spa-js';

class AuthClient {
  constructor() {
    this.auth0Client = createAuth0Client({
      domain: process.env.AUTH_DOMAIN,
      clientId: process.env.AUTH_CLIENT_ID,
      authorizationParams: {
        redirect_uri: window.location.origin + '/callback',
        audience: process.env.AUTH_AUDIENCE
      }
    }).catch((error) => {
      console.error('Failed to initialize Auth0 client:', error);
      throw error;
    });
  }

  login() {
    return this.auth0Client.then((client) => client.loginWithRedirect());
  }

  logout() {
    return this.auth0Client.then((client) =>
      client.logout({
        logoutParams: {
          returnTo: window.location.origin
        }
      })
    );
  }

  handleRedirectCallback() {
    return this.auth0Client.then((client) => client.handleRedirectCallback());
  }

  getAccessToken() {
    return this.auth0Client.then((client) =>
      client.getTokenSilently({
        cacheMode: 'on'
      })
    );
  }

  isAuthenticated() {
    return this.auth0Client.then((client) => client.isAuthenticated());
  }
}

// 同じクライアントデータを使い続けたいためシングルトンとして利用する
export default new AuthClient();
